import { render } from "./CompanyProfile.vue?vue&type=template&id=d331d938&scoped=true&bindings={}"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts"

import "./CompanyProfile.vue?vue&type=style&index=0&id=d331d938&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d331d938"

export default script